import { PasswordField as SerendiePasswordField } from "@serendie/ui";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { JSX } from "react";
import "./Styles.scss";
import React from "react";

export class PasswordField extends BaseComponent<IPasswordFieldProps, IPasswordFieldState>
{
    public static requiredLabel?: string;

    public render(): JSX.Element
    {
        return <SerendiePasswordField
            {...this.props}
            className={`${this.props.className ?? ''} serendie-passwordfield`}
            requiredLabel={this.props.requiredLabel ?? PasswordField.requiredLabel}
        />
    }
}

export interface IPasswordFieldProps extends React.ComponentProps<typeof SerendiePasswordField> { }

export interface IPasswordFieldState { }
